import { Box, BoxProps } from '@chakra-ui/react';
import { forwardRef } from '@melio/platform-utils';

export const Content = forwardRef<BoxProps, 'div'>((props: BoxProps, ref) => (
  <Box {...props} data-component="NewSinglePaymentStepLayout.Content" data-testid="layout-content" ref={ref} />
));

Content.displayName = 'NewSinglePaymentStepLayout.Content';
